import type { OpportunityRoomAsset } from '~/hooks/apis/offers/useGetOffer';

import { toSortableTimestamp } from '~/services/TimeService';

export const RELATED_PREVIEW_LIMIT = 6;
export const ACCOUNT_OFFER_PARAM = 'offer';
export const OFFER_LINKS_UNAVAILABLE_MESSAGE =
  "Couldn't check which Opportunities have an offer, so none are linked to Offer Builder.";

export function accountPath(accountId: string, offerId?: string, suffix = '') {
  const path = `/accounts/${accountId}${suffix}`;
  return offerId ? `${path}?${ACCOUNT_OFFER_PARAM}=${encodeURIComponent(offerId)}` : path;
}

export function relatedCountLabel(count: number) {
  return count > RELATED_PREVIEW_LIMIT ? `${RELATED_PREVIEW_LIMIT}+` : String(count);
}

function latestKnownTimestamp(opportunity: App.OpportunityPage) {
  const timestamps = [
    opportunity.contract_and_commercial?.planned_end_datele__c,
    opportunity.run_dates?.deal_run_date__c,
    opportunity.sales_and_forecast?.closedate,
    opportunity.opportunity_info?.createddate,
  ]
    .map(toSortableTimestamp)
    .filter((timestamp): timestamp is number => timestamp !== null);

  return timestamps.length > 0 ? Math.max(...timestamps) : null;
}

export function sortOpportunitiesByLatestDate(opportunities: Array<App.OpportunityPage>) {
  return [...opportunities].sort((a, b) => {
    const aDate = latestKnownTimestamp(a);
    const bDate = latestKnownTimestamp(b);

    if (aDate === bDate) {
      return 0;
    }
    if (aDate === null) {
      return 1;
    }
    if (bDate === null) {
      return -1;
    }
    return bDate - aDate;
  });
}

export function sortAssetsByRecordType(assets: Array<OpportunityRoomAsset>) {
  return [...assets].sort(
    (a, b) =>
      (a.recordtype__name ?? '').localeCompare(b.recordtype__name ?? '') || (a.name ?? '').localeCompare(b.name ?? ''),
  );
}

export function toSortableAmount(value?: string | number | null) {
  if (value === null || value === undefined || value === '') {
    return null;
  }

  const amount = Number(value);
  return Number.isFinite(amount) ? amount : null;
}
